"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskEmail = void 0;
const maskPart = (part) => `${part.slice(0, 1)}***`;
const maskEmail = (email) => {
    const [mailbox = "", domain = ""] = email.trim().split("@");
    const extensionStart = domain.lastIndexOf(".");
    if (!mailbox || extensionStart <= 0) {
        return "***";
    }
    return `${maskPart(mailbox)}@${maskPart(domain.slice(0, extensionStart))}${domain.slice(extensionStart)}`;
};
exports.maskEmail = maskEmail;
